'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var options = {
    template: require('./detail.html'),
    bindings: {
        brand: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "$state", "Analytics", function controller($scope, productOverviewService, Enums, common, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.newsitems = [];
        vm.$onInit = init;

        function init() {
            common.navigationMenu.setBrandsActive();
            var pageTitle = vm.brand.name;
            common.setTitle(pageTitle);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/brands/' + vm.brand.id, pageTitle);

            //put the brandname in the params so it can be used on the news page breadcrumbs
            $state.params.breadcrumbName = vm.brand.name;

            vm.productOverviewModel = productOverviewService.init(Enums.searchContext.brand.id);
            productOverviewService.getProductsByBrand(true, vm.productOverviewModel, vm.brand.id).then(function (model) {
                vm.productOverviewModel = model;
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByBrand(false, vm.productOverviewModel, vm.brand.id).then(function (model) {
                    vm.productOverviewModel = model;
                    document.body.scrollTop = document.documentElement.scrollTop = 0;
                });
            });
        }
    }]
};

exports.default = options;


//////////////////
// WEBPACK FOOTER
// ./features/brand/detail.js
// module id = 895
// module chunks = 0